import React from 'react';
import { NavLink } from 'react-router-dom';
import Badge from 'react-bootstrap/Badge';
import styles from '../styles/About.module.css';

export default function About() {
    return (
        <div className={styles.pageShell}>
            <div className={styles.pageContainer}>
                <div className={styles.aboutSplit}>
                    <section className={styles.aboutPanel}>
                        <div className={styles.aboutBody}>
                            <div className={styles.profileGrid}>


                                <div className={styles.introCopy}>
                                    <span className={styles.eyebrow}>
                                        Studio profile
                                    </span>

                                    <h1 className={styles.headingMain}>
                                        Stories, systems,<br></br> and digital work <br></br>built
                                        to move people.
                                    </h1>

                                    <p className={styles.introText}>
                                        Meshae Studios is an independent creative
                                        studio founded and led by Shaun Dawson. We
                                        combine strategy, design, development, and
                                        story to create work that feels sharp,
                                        useful, and culturally grounded.
                                    </p>

                                    <p className={styles.introText}>
                                        Shaun leads creative direction and works
                                        with a trusted network of designers,
                                        developers, producers, writers, and
                                        specialists—assembling the right team for
                                        each project rather than treating every
                                        brief like a one-person operation.
                                    </p>

                                    <NavLink
                                        to="/new-client"
                                        className={styles.exploreLink}
                                    >
                                        Start a project <span aria-hidden="true">→</span>
                                    </NavLink>
                                </div>
                            </div>

                            <div className={styles.detailRows}>
                                <div className={styles.detailRow}>
                                    <span className={styles.detailLabel}>
                                        Services
                                    </span>

                                    <div className={styles.detailValue}>
                                        <Badge className={styles.customPill}>
                                            Web Design
                                        </Badge>
                                        <Badge className={styles.customPill}>
                                            App Development
                                        </Badge>
                                        <Badge className={styles.customPill}>
                                            Brand Identity
                                        </Badge>
                                        <Badge className={styles.customPill}>
                                            Content Strategy
                                        </Badge>
                                        <Badge className={styles.customPill}>
                                            Story Development
                                        </Badge>
                                        <Badge className={styles.customPill}>
                                            Script Services
                                        </Badge>
                                        <Badge className={styles.customPill}>
                                            Technical Consulting
                                        </Badge>
                                    </div>
                                </div>

                                <div className={styles.detailRow}>
                                    <span className={styles.detailLabel}>
                                        Studio model
                                    </span>

                                    <p className={styles.detailText}>
                                        Founder-led creative direction with a
                                        flexible network of collaborators,
                                        production partners, and technical
                                        specialists.
                                    </p>
                                </div>

                                <div className={styles.detailRow}>
                                    <span className={styles.detailLabel}>
                                        Background
                                    </span>

                                    <p className={styles.detailText}>
                                        Built on experience across Vimeo, HubSpot,
                                        and Confiant, plus independent work in
                                        digital storytelling, culture, and social
                                        impact.
                                    </p>
                                </div>

                                <div className={styles.detailRow}>
                                    <span className={styles.detailLabel}>
                                        Selected work
                                    </span>

                                    <div className={styles.projectLinks}>
                                        <a
                                            href="https://assignedsex.substack.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.textLink}
                                        >
                                            Assigned Sex: Unarchived ↗
                                        </a>

                                        <a
                                            href="https://badgesvsshields.substack.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.textLink}
                                        >
                                            A Few Mad Apples ↗
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <aside className={styles.visualPanel} aria-hidden="true">
                        <img
                            src="https://5688825.fs1.hubspotusercontent-na1.net/hubfs/5688825/meshaestudios.com/Shaun-Toni-Smailagic-2025-14.jpg"
                            alt=""
                            className={styles.visualImage}
                        />

                        <div className={styles.visualOverlay} />


                    </aside>
                </div>
            </div>
        </div>
    );
}